import { styled } from "../../../../../../styles";

export const ToolbarContainer = styled("div", {
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: "12px",
  position: "absolute",
  top: "2px",
  left: "320px",
  zIndex: 1,
});

export const ToggleButton = styled("button", {
  height: "32px",
  padding: "0 18px",
  borderRadius: "16px",
  border: "none",
  backgroundColor: "$gray-50",
  color: "$black",
  fontFamily: "$openSans",
  fontSize: "13px",
  fontWeight: 500,
  cursor: "pointer",
  transition: "background-color 0.15s, color 0.15s",

  "&:hover:not(:disabled)": {
    backgroundColor: "$gray-60",
  },

  "&:disabled": {
    cursor: "not-allowed",
    opacity: 0.7,
  },

  "&[data-active=true]": {
    backgroundColor: "#E8DAFF",
    color: "#48397D",
  },

  "&[data-active=true]:hover:not(:disabled)": {
    backgroundColor: "#DCC8FF",
  },
});

export const AssignedPill = styled("div", {
  display: "inline-flex",
  alignItems: "center",
  gap: "8px",
  height: "32px",
  padding: "0 14px",
  borderRadius: "16px",
  backgroundColor: "#E8DAFF",
  color: "#48397D",
  fontFamily: "$openSans",
  fontSize: "13px",
  fontWeight: 500,
});

export const RemoveAssigneeButton = styled("button", {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: "16px",
  height: "16px",
  padding: 0,
  border: "none",
  backgroundColor: "transparent",
  color: "#48397D",
  fontFamily: "$openSans",
  fontSize: "16px",
  lineHeight: 1,
  cursor: "pointer",

  "&:hover": {
    opacity: 0.7,
  },
});

export const assigneePopupCss = {
  maxHeight: "320px",
  overflowY: "auto",
  minWidth: "320px",
  borderRadius: "8px",
  boxShadow: "0 4px 16px rgba(0, 0, 0, 0.08)",
  border: "1px solid #E6E6E6",
} as const;

export const PopupWrapper = styled("div", {
  minWidth: "320px",
  borderRadius: "8px",
  backgroundColor: "$white",
  boxShadow: "0 4px 16px rgba(0, 0, 0, 0.08)",
  border: "1px solid #E6E6E6",
  overflow: "hidden",
});

export const SearchRow = styled("div", {
  padding: "8px 10px",
  borderBottom: "1px solid #E6E6E6",
  backgroundColor: "$white",
});

export const SearchInput = styled("input", {
  width: "100%",
  height: "32px",
  padding: "0 10px",
  border: "none",
  backgroundColor: "transparent",
  fontFamily: "$openSans",
  fontSize: "13px",
  color: "$black",
  outline: "none",

  "&::placeholder": {
    color: "$gray-100",
  },
});
